import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderService } from 'src/app/services/order.service';
import { Order } from 'src/app/models/order';
import { NgbDateAdapter, NgbTimeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { TimeNativeAdapter } from 'src/app/adapters/native-time-adapter';
import { UtilitiesService } from 'src/app/services/utilities.service';
import { CustomerService } from 'src/app/services/customer.service';
import { ProductService } from 'src/app/services/product.service';
import { UnitTypeService } from 'src/app/services/unit-type.service';
import { PresentationsService } from 'src/app/services/presentations.service';
import { Customer } from 'src/app/models/customer';
import { CustomerAddress } from 'src/app/models/customer-address';
import { Product } from 'src/app/models/product';
import { UnitType } from 'src/app/models/unit-type';
import { Presentation } from 'src/app/models/presentation';
import { NativeDateAdapter } from 'src/app/adapters/native-date-adapter';
import { ToastrManager } from 'ng6-toastr-notifications';
import { LogisticEventsService } from 'src/app/services/logistic-events.service';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-order-edit',
  templateUrl: './order-edit.component.html',
  styleUrls: ['./order-edit.component.css'],
  providers: [
    {provide: NgbDateAdapter, useClass: NativeDateAdapter}, 
    {provide: NgbTimeAdapter, useClass: TimeNativeAdapter}
  ]
})
export class OrderEditComponent implements OnInit {

  loading:boolean = false;
  order:Order = new Order();
  customers:Customer[] = [];
  sourceCustomers:Customer[] = [];
  customerAddresses:CustomerAddress[] = [];
  sourceCustomerAddresses:CustomerAddress[] = [];
  products:Product[] = [];
  unitTypes:UnitType[] = [];
  presentations:Presentation[] = [];
  canDelete:boolean = false;
  showHowChanges:boolean = true;

  constructor(actRoute:ActivatedRoute, private orderServ:OrderService, private utl:UtilitiesService, private custServ:CustomerService, private prodServ:ProductService, private unitTypeServ:UnitTypeService, private presServ:PresentationsService, private toastr:ToastrManager, private logisticEv:LogisticEventsService, private authServ:AuthService, private router : Router) { 
    this.loading = true;
    actRoute.params.subscribe(params => {
      this.orderServ.getOrder(params.id).then(order => {
        if(order.status == "Creada"){
          this.order = order;
          this.order.delivery_date = new Date(this.order.delivery_date);
          if (this.authServ.is('sales') || this.authServ.is('logistic')) {
            this.showHowChanges = false;
          }

          if (!this.order.who_changed && this.authServ.is('sales')) {
            this.order.who_changed = 'Ventas';
          } else if (!this.order.who_changed && this.authServ.is('logistic')) {
            this.order.who_changed = 'Transito';
          }
          this.searchAll();
        }else {
          this.router.navigate(['/order/'+order.id]);
        }        
        this.loading = false;
      });
    });
    this.canDelete = this.authServ.can('destroy-order');
  }

  ngOnInit() { }

  searchAll () {
    this.custServ.getCustomers('Cliente').then(customers => {
      this.customers = customers;
      this.order.customer = this.customers.find(c => c.id == this.order.customer_id);
      this.customerAddresses = this.order.customer.directions;
      this.order.customer_address = this.order.customer.directions.find(ca => ca.id == this.order.customer_address_id);
    });

    this.custServ.getCustomers('Intercompañia').then(sourceCustomers => {
      this.sourceCustomers = sourceCustomers;
      this.order.source_customer = this.sourceCustomers.find(c => c.id == this.order.source_customer_id);
      this.sourceCustomerAddresses = this.order.source_customer.directions;
      this.order.source_customer_address = this.order.source_customer.directions.find(ca => ca.id == this.order.source_customer_address_id);
    });

    this.prodServ.getProducts().then(products => {
      this.products = products;
      this.order.product = this.products.find(p => p.id == this.order.product_id);
    });
    
    this.presServ.getPresentations().then(presentations => {
      this.presentations = presentations;
      this.order.presentation = this.presentations.find(p => p.id == this.order.presentation_id);
    });

    this.unitTypeServ.getTypes().then(unitTypes => {
      this.unitTypes = unitTypes;
      this.order.unit_type = this.unitTypes.find(u => u.id == this.order.unit_type_id);
    });
  }

  deleteOrder(){
    this.orderServ.deleteOrder(this.order)
      .then(resp => {
        this.order.status = 'Cancelado';
        this.toastr.successToastr("Orden eliminada correctamente!");
        this.logisticEv.sendOrderDeleted(this.order);
      }).catch(resp => {
        if (resp.error.message) {
          this.toastr.errorToastr(resp.error.message);
        } else {
          this.toastr.errorToastr('Error al eliminar orden');
        }
      });
  }

  changeCustomer() {
    this.customerAddresses = this.order.customer.directions;
    if(this.customerAddresses.length) {
      this.order.customer_address = this.customerAddresses[0];
      this.order.customer_address_id = this.customerAddresses[0].id;
    }
  }

  changeSourceCustomer() {
    this.sourceCustomerAddresses = this.order.source_customer.directions;
    if(this.sourceCustomerAddresses.length) {
      this.order.source_customer_address = this.sourceCustomerAddresses[0];
      this.order.source_customer_address_id = this.sourceCustomerAddresses[0].id;
    }
  }

  edit(event) {
    event.preventDefault();

    this.loading = true;
    this.order.customer_address_id = this.order.customer_address.id;
    this.order.source_customer_address_id = this.order.source_customer_address.id;
    this.order.customer_id = this.order.customer.id;
    this.order.source_customer_id = this.order.source_customer.id;
    this.order.product_id = this.order.product.id;
    this.order.unit_type_id = this.order.unit_type.id;
    this.order.presentation_id = this.order.presentation.id;

    this.orderServ.putOrder(this.order).then(ord => {
      if(ord.id){
        this.order = ord;
        this.order.delivery_date = new Date(this.order.delivery_date);

        this.order.customer = this.customers.find(c => c.id == this.order.customer_id);
        this.customerAddresses = this.order.customer.directions;
        this.order.customer_address = this.order.customer.directions.find(ca => ca.id == this.order.customer_address_id);
        this.order.source_customer = this.sourceCustomers.find(c => c.id == this.order.source_customer_id);
        this.sourceCustomerAddresses = this.order.source_customer.directions;
        this.order.source_customer_address = this.order.source_customer.directions.find(ca => ca.id == this.order.source_customer_address_id);
        this.order.product = this.products.find(p => p.id == this.order.product_id);
        this.order.presentation = this.presentations.find(p => p.id == this.order.presentation_id);
        this.order.unit_type = this.unitTypes.find(u => u.id == this.order.unit_type_id);

        this.loading = false;
        this.toastr.successToastr('Actualizado Correctamente');
        this.logisticEv.sendOrderChangeInfo(ord);
      }else{
        this.loading = false;
        this.toastr.errorToastr(ord['message']);
        this.router.navigate(['/order/'+this.order.id]);
      }
    });
  }

}
